<template>
    <div id="app" class="page-item h-full">
        <router-view />
    </div>
</template>
<script>

export default {
    name: "App",
    components: {
    },
    data() {
        return {
        };
    },
	computed: {
		isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
		isCommenting() {
			return this.$store.getters.isCommenting
		},
		theme() {
			return this.$store.getters.theme
		},
		backgroundColor() {
			return this.$store.getters.backgroundColor
		},
		backgrounds() {
			return this.$store.getters.backgrounds
		},
		activeBoard() {
			return this.$store.getters.activeBoard
		},
        uploadingInProcess() {
            return this.$store.getters.uploadingInProcess
        },
	},
	watch: {
		activeBoard(newVal) {
			if (newVal?.color.length > 0) {
				this.$store.dispatch('setBackgroundColor', newVal?.color);
				document.body.style.background = this.backgroundColor
			} else {
				this.$store.dispatch('setBackgroundColor', '#192536');
				document.body.style.background = '#192536'
			}
		}
	},
	created() {
		if(localStorage.getItem('theme')) {
			// If else statements for compatibility
			if (localStorage.getItem('theme').includes('light')) {
				localStorage.setItem('theme', 'light')
			} else {
				localStorage.setItem('theme', 'dark')
			}

			this.$store.dispatch('setTheme', 'theme-' + localStorage.getItem('theme'))
		} else {
			const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
			if (darkModeMediaQuery.matches) {
				localStorage.setItem('theme', 'dark')
			} else {
				localStorage.setItem('theme', 'light')
			}

			this.$store.dispatch('setTheme', 'theme-' + localStorage.getItem('theme'))
		}
		document.body.classList.add(this.theme)
	},
	mounted() {
		document.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				if (this.isTaskEditing || this.isCommenting || document.activeElement.parentElement.getAttribute('data-active')) return

				const modals = document.querySelectorAll('.modal-backdrop, .tags-dropdown-input')
				if (modals.length) {
					if (modals[modals.length - 1].classList.contains('tags-dropdown-input')) {
						modals[modals.length - 1].blur()
					} else {
						modals[modals.length - 1].click()
					}
				}
			}
		})

		window.onbeforeunload = (e) => {
			if(this.uploadingInProcess) return "are you sure you want to leave?";
		}
	}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700&display=swap');
@import "@/assets/scss/_common.scss";
@import "@/assets/scss/_theme-dark.scss";
//TODO unhide this to enable light theme
@import "@/assets/scss/_theme-light.scss";

* {
	box-sizing: border-box;
	font-family: $font-family-base;
}

body {
	min-width: 320px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	padding: 0;
	margin: 0;
	background-color: $bg-color-base;
	color: var(--primary-text);
	font: $font-weight-base $font-size-base $font-family-base;
	line-height: $line-height-base;
}

body,
html {
	height: 100%;
}

#app {
	position: relative;
	overflow: hidden;
}


img, video {
	max-width: 100%;
	height: auto;
}

a {
	text-decoration: none;
	transition: color .3s;
	color: inherit;

	&:hover {
		text-decoration: none;
	}
}

table {
	text-align: left;
	border-collapse: collapse;

	th,
	td {
		vertical-align: middle;
		padding: calc($gap-size / 2);
	}
}

h1 {
	margin: 0 0 24px;
	font-size: $h1-font-size;
	font-weight: $font-weight-title;
}

h2 {
	margin: 0 0 15px;
	font-size: $h2-font-size;
	font-weight: $font-weight-title;
}

h3 {
	margin: 0 0 15px;
	font-size: $h3-font-size;
	font-weight: $font-weight-title;
}

h4 {
	margin: 0 0 15px;
	font-size: $h4-font-size;
	font-weight: $font-weight-title;
}

h5 {
	margin: 0 0 15px;
	font-size: $h5-font-size;
	font-weight: $font-weight-title;
}

h6 {
	margin: 0 0 15px;
	font-size: $h6-font-size;
	font-weight: $font-weight-title;
}

p {
	margin: 0 0 15px;
}

@for $i from 1 through 12 {
	.v-column-#{$i} {
		flex-basis: #{calc(100 * $i / 12) + '%'};
	}
}

[class*="v-container"] {
	width: 100%;
	padding: 0 $gap-size;

	&.v-layout {
		display: flex;
		flex-wrap: wrap;
	}
}

.v-col-holder {
	display: flex;
	flex-wrap: wrap;
}

[class*="v-column-"] {
	padding: 0 $gap-size;
}

.v-container-bounded {
	@include media-up(md) {
		max-width: 1440px;
		margin: 0 auto;
	}
}

.loading {
	position: relative;
	pointer-events: none;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba($bg-color-base, .85);
		z-index: 10;
		pointer-events: none;
	}

	&:after {
		content: '';
		position: absolute;
		top: 20px;
		left: 50%;
		transform: translateX(-50%);
		width: 50px;
		height: 50px;
		z-index: 11;
		background-color: $gray-5;
		border-radius: 100%;
		-webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
		animation: sk-scaleout 1.0s infinite ease-in-out;
	}
}

.h-full {
	height: 100%;
}

.offline-alert {
	position: fixed;
	z-index: 999;
}

@-webkit-keyframes sk-scaleout {
	0% { -webkit-transform: scale(0) }
	100% {
		-webkit-transform: scale(1.0);
		opacity: 0;
	}
}

@keyframes sk-scaleout {
	0% { 
		-webkit-transform: scale(0);
		transform: scale(0);
	} 100% {
		-webkit-transform: scale(1.0);
		transform: scale(1.0);
		opacity: 0;
	}
}
</style>